module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "c-header u-fixed u-marg-x-auto u-zindex--2 u-flex u-flex-ai--center u-flex-jc--space-between",
    class: ['is-color-' + _vm.activeColor, _vm.isVisible ? 'is-visible' : 'is-hidden']
  }, [(_vm.$root.componentId === _vm.$root.CONFIG.pages.home.name) ? _c('div', {
    staticClass: "c-header__filter u-flex u-flex-ai--center u-cursor-pointer u-click-area-xxs",
    class: [_vm.filterLabelIsVisible ? 'is-visible' : 'is-hidden'],
    on: {
      "click": function($event) {
        _vm._showFilters()
      }
    }
  }, [_c('div', {
    staticClass: "c-header__filter__icon-container u-flex u-hide@sm u-flex-ai--center u-flex-jc--center u-bradius--circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "c-header__filter__label t-link u-marg-l-xs u-marg-l-0@sm t-text--xxs t-fweight--bold u-uppercase u-color--gray"
  }, [_vm._v("Search By")])]) : _vm._e(), _vm._v(" "), ([_vm.$root.CONFIG.pages.about.name, _vm.$root.CONFIG.pages['404'].name].indexOf(_vm.$root.componentId) !== -1) ? _c('router-link', {
    staticClass: "c-header__logotype t-link u-relative u-hide@sm u-w2of14 u-w5of18@lg u-click-area-xxs",
    attrs: {
      "to": _vm.$root.getPageURLFromName('home')
    }
  }, [_c('img', {
    staticClass: "u-fit-w",
    attrs: {
      "src": "/static/medias/images/logotype--gray.png",
      "alt": "Immersive Garden - Logotype",
      "title": "Immersive Garden - Logotype"
    }
  })]) : _vm._e(), _vm._v(" "), ([_vm.$root.CONFIG.pages.about.name, _vm.$root.CONFIG.pages['404'].name].indexOf(_vm.$root.componentId) !== -1) ? _c('div', {
    staticClass: "u-block@sm u-w2of14 u-w5of18@lg u-w5of10@sm"
  }) : _vm._e(), _vm._v(" "), (_vm.$root.componentId === _vm.$root.CONFIG.pages.case.name) ? _c('router-link', {
    staticClass: "c-header__back t-link t-text--xs-l t-fweight--bold u-uppercase u-click-area-xxs",
    attrs: {
      "to": _vm.$root.getPageURLFromName('home')
    }
  }, [_c('span', [_vm._v("Back")])]) : _vm._e(), _vm._v(" "), (_vm.$root.componentId === _vm.$root.CONFIG.pages.about.name) ? _c('div', {
    staticClass: "c-header__close t-text--xs-l t-fweight--bold u-uppercase u-cursor-pointer u-click-area-xxs",
    on: {
      "click": _vm._onClickOnClose
    }
  }, [_c('span', {
    staticClass: "u-hide@sm"
  }, [_vm._v("Close")]), _vm._v(" "), _c('img', {
    staticClass: "c-header__close__icon u-hide",
    attrs: {
      "src": "/static/medias/images/close--white.png",
      "alt": "Close",
      "title": "Close"
    }
  })]) : _c('router-link', {
    staticClass: "c-header__about t-link t-text--xs-l t-fweight--bold u-uppercase u-click-area-xxs",
    attrs: {
      "to": _vm.$root.getPageURLFromName('about')
    }
  }, [_c('span', [_vm._v("About Us")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a235ae1"}!./src/scripts/components/app-header/template.html
// module id = 141
// module chunks = 0